import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { useSite } from "@/contexts/SiteContent";
import { Icon } from "@/components/Icon";
import { resolveAssetUrl } from "@/lib/api";
import RichText from "@/components/RichText";

export default function ServicesHubPage() {
  const { content } = useSite();
  const p = content?.services_page || {};
  const hero = p.hero || {};
  const items = p.items || [];
  const heroImg = resolveAssetUrl(hero.image_url || "");

  return (
    <div>
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-16 pb-12 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <motion.div initial={{opacity:0, y:14}} animate={{opacity:1, y:0}} transition={{duration:0.5}}>
            <div className="overline">{hero.eyebrow}</div>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight mt-3 max-w-3xl">{hero.title}</h1>
            <RichText html={hero.subtitle} variant="subtitle" className="mt-6 max-w-3xl"/>
          </motion.div>
        </div>
        {heroImg && (
          <motion.div initial={{opacity:0, scale:0.95}} animate={{opacity:1, scale:1}} transition={{duration:0.6}} className="lg:col-span-5">
            <img src={heroImg} alt="" className="w-full rounded-3xl shadow-xl aspect-[4/3] object-cover"/>
          </motion.div>
        )}
      </section>

      {hero.description && (
        <section className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 pb-12">
          <RichText html={hero.description} variant="body" testid="services-description"/>
        </section>
      )}

      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pb-20 grid grid-cols-1 lg:grid-cols-3 gap-5">
        {items.map((s, idx) => (
          <motion.div key={s.slug} initial={{opacity:0, y:16}} whileInView={{opacity:1, y:0}} viewport={{once:true}} transition={{duration:0.4, delay: idx*0.07}}>
            <Link to={`/p/${s.slug}`} data-testid={`hub-service-${s.slug}`} className="card-flat p-8 group h-full block">
              <div className="h-12 w-12 grid place-items-center rounded-xl bg-saffron/10 text-saffron">
                <Icon name={s.icon} className="h-5 w-5" strokeWidth={1.8}/>
              </div>
              <h3 className="font-display text-2xl font-bold mt-5">{s.title}</h3>
              <p className="text-sm text-ink-muted mt-2 leading-relaxed">{s.blurb}</p>
              <div className="mt-6 text-sm font-semibold text-saffron inline-flex items-center gap-1.5">
                Explore <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform"/>
              </div>
            </Link>
          </motion.div>
        ))}
      </section>
    </div>
  );
}
